module.exports = __webpack_public_path__ + "static/media/imageIcon.852fc2da.svg";